import { Box, Typography, useTheme } from '@mui/material'
import { TimelineEvent } from './TimelineEvent'
import data from '../../data/data.json'

export function TimelineTab() {
  const theme = useTheme()
  
  return (
    <Box>
      <Box sx={{ mb: 4 }}>
        <Typography 
          variant="h4" 
          component="h2" 
          gutterBottom
          sx={{ 
            fontWeight: 700, 
            fontSize: { xs: '2rem', sm: '2.5rem' },
            background: theme.palette.mode === 'dark' 
              ? 'linear-gradient(135deg, #5facf3 0%, #4392ed 100%)' 
              : 'linear-gradient(135deg, #004ffe 0%, #004da1 100%)',
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            letterSpacing: '-0.02em',
          }}
        >
          Project Timeline
        </Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary', fontSize: { xs: '0.875rem', sm: '1rem' } }}>
          {data.project.timeline.start} to {data.project.timeline.present} from start to release
        </Typography>
      </Box>

      {/* Phase legend */}
      <Box sx={{ display: 'flex', gap: 3, mb: 4, flexWrap: 'wrap' }}>
        {[
          { name: 'Foundation', color: '#1976D2' },
          { name: 'Multi-Tenancy', color: '#7B1FA2' },
          { name: 'Enterprise-Grade Features', color: '#00897B' },
          { name: 'Production Excellence', color: '#C62828' },
        ].map((phase) => (
          <Box key={phase.name} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box
              sx={{
                width: 10,
                height: 10,
                borderRadius: '50%',
                bgcolor: phase.color,
              }}
            />
            <Typography variant="caption" sx={{ fontWeight: 500, color: 'text.secondary' }}>
              {phase.name}
            </Typography>
          </Box>
        ))}
      </Box>

      {/* Timeline events */}
      <Box>
        {data.timeline.map((event, index) => (
          <TimelineEvent
            key={event.id}
            event={event}
            isLast={index === data.timeline.length - 1}
          />
        ))}
      </Box>
    </Box>
  )
}
